(function() {
    angular
        .module("app")
        .controller("DeleteUserModalController", DeleteUserModalController)

    DeleteUserModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "usersService",
        "userMessagingService",
        "user"
    ]

    function DeleteUserModalController(
        $state,
        $scope,
        $uibModalInstance,
        usersService,
        userMessagingService,
        user
    ){
        "use strict"

        $scope.user = {
            username: user.username
        }

        $scope.ok = function() {
            $uibModalInstance.close(usersService.deleteUser(
                user.id,
                function() {
                    //Success
                    gtag("event", "delete_user", { user_id: user.id })
                    $state.go("users", {}).then(() => {
                        userMessagingService.success("User Successfully Deleted")
                    })
                },
                function(error) {
                    //Failure
                    userMessagingService.error(error)
                }
            ))
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
